<template>
  <transition name="fade" @after-leave="afterLeave">
    <router-view></router-view>
  </transition>


</template>

<script>
export default {
  name: 'Content',
  methods: {
    afterLeave() {
      this.$root.$emit('triggerScroll');
    },
  },
  data() {
    return {

    };
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/pages/layout/Content.vue